module.exports = __webpack_public_path__ + "static/media/plastic.2e356b6a.svg";